import React from "react";
import { connect } from "react-redux";

import * as actions from "../../store/actions";

const LoginButton = ({ userId, onSetSettingsModal }) => (
  <button onClick={() => onSetSettingsModal(true)}>
    {userId ? "Account Settings" : "Log In"}
  </button>
);

const mapStateToProps = (state) => ({
  userId: state.userId,
});

const mapDispatchToProps = (dispatch) => ({
  onSetSettingsModal: (show) => dispatch(actions.setSettingsModal(show)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginButton);
